import React from 'react';

const TwitterFeed = () => {
  return (
    <>
      <style>{`
        .twitter-card {
          background-color: #6b0f1a;
          border-radius: 16px;
          color: #fff;
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 24px;
          padding: 28px 32px;
          box-sizing: border-box;
          cursor: pointer;
          transition: transform 0.2s, box-shadow 0.2s;
          max-width: 100%;
          text-decoration: none;
        }
        .twitter-card:hover {
          transform: scale(1.01);
          box-shadow: 0 8px 24px rgba(107, 15, 26, 0.3);
        }
        .twitter-logo {
          flex-shrink: 0;
          width: 56px;
          height: 56px;
        }
        .twitter-text h3 {
          margin: 0 0 6px 0;
          font-size: 1.4rem;
          color: #fff;
          font-weight: 600;
          letter-spacing: 0.3px;
        }
        .twitter-text p {
          color: #e8c5c5;
          margin: 0;
          font-size: 1rem;
          line-height: 1.4;
          font-weight: 400;
        }

        @media (max-width: 600px) {
          .twitter-card {
            flex-direction: column;
            align-items: flex-start;
            padding: 20px 24px;
            gap: 16px;
          }
          .twitter-logo {
            width: 44px;
            height: 44px;
          }
          .twitter-text h3 {
            font-size: 1.15rem;
          }
          .twitter-text p {
            font-size: 0.95rem;
          }
        }
      `}</style>

      <a 
        href="https://x.com/Bienestar_Hgo" 
        target="_blank" 
        rel="noopener noreferrer"
        className="twitter-card"
      >
        {/* Logo X */}
        <svg className="twitter-logo" viewBox="0 0 24 24" fill="#fff">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
        
        {/* Texto */}
        <div className="twitter-text">
          <h3>@Bienestar_Hgo</h3>
          <p>
            Sigue las últimas noticias y actividades de la Secretaría de Bienestar e Inclusión Social.
          </p>
        </div>
      </a>
    </>
  );
};

export default TwitterFeed;